import type { History } from "history";
import { createBrowserHistory } from "history";

let history: History;

const openCatalogBrowserHistory = () => {
  if (typeof window === "undefined") return undefined;

  return (history ||= createBrowserHistory());
};

export { openCatalogBrowserHistory };
